import { useNavigate } from 'react-router-dom';
import { CardList } from '~/pages/MyPage';
import { FullScreenLoading } from '~/components/common';
import { NoMyPageItemMessage } from '~/components/common/NoItemMessage';
import { useGetMyCreationListQuery } from '~/features/user';
import { useCreateChatRoom } from '~/hooks';
import { GAEvent } from '~/utils';
import { GA, PAGE_ROUTE } from '~/constants';
import { useUserStore } from '~/store';
import Card from '../Card/Card';

export default function MyCharacter() {
  const navigate = useNavigate();
  const { email } = useUserStore((state) => ({
    email: state.email,
  }));

  const { data } = useGetMyCreationListQuery();
  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();

  const handleEditCharacter = (id: string) => {
    navigate(PAGE_ROUTE.EDIT_CHARACTER, { state: id });
  };

  const handleGenerateCharacterClick = () => {
    // send GA event : CLICK_GENERATE_CHARACTER
    GAEvent(email, GA.ACTION.CLICK_GENERATE_CHARACTER, {
      button_type: 'mypage',
    });
    navigate(PAGE_ROUTE.CREATE_NEW_CHARACTER);
  };

  if (data.length === 0) {
    return (
      <NoMyPageItemMessage
        message={'Generate your first character'}
        buttonTitle={'Generate character'}
        onButtonClick={handleGenerateCharacterClick}
      />
    );
  }

  return (
    <>
      {isCreateRoomPending && <FullScreenLoading />}

      <CardList>
        {data.map((character) => {
          const { character_id, character_name, character_image, type } =
            character;
          return (
            <Card
              key={character_id}
              id={character_id}
              name={character_name}
              image={character_image}
              type='Edit'
              onClick={() =>
                handleCreateRoomClick({
                  id: character_id,
                  type,
                  image: character_image,
                })
              }
              onIconClick={() => handleEditCharacter(character_id)}
            />
          );
        })}
      </CardList>
    </>
  );
}
